<template>
  <div>
        <g-master name="distribucion"
                  :endpoint="master.endpoint"
                  :tableSetup="master.tableSetup"
                  :modalFieldsSetup="master.modalFieldsSetup"
                  :actions="false"
                  ref="masterComponent"
                  @params="paramsTable"
        >
          <template slot="customButton">
            <g-btn-excel :endpoint="endpointExcel" :params="paramsExcel" :fileName="fileNameExcel"/>
          </template>
          <template slot="expandedRowRender" slot-scope="{text}">
            <template v-for="ve in master.valoresExpandidos">
              {{ve.label}}: <span style="font-weight: bold;">{{text[ve.column]}}</span><br/>
            </template>
          </template>
        </g-master>
  </div>
</template>
<script>
  export default {
    data () {
      return {
        fileNameExcel: 'distribucion_historico',
        paramsT: {},
        endpointExcel: 'distribution_cc_hist_/downloadExcel',
        master: {
          valoresExpandidos: [
            {label: 'Creado por', column: 'created_by'},
            {label: 'Creado', column: 'created_on'},
            {label: 'Modificado por', column: 'modified_by'},
            {label: 'Modificado', column: 'modified_on'}
          ],
          endpoint: 'distribution_cc_hist',
          tableSetup: {
            customSlots: ['expandedRowRender'],
            tableConfig: {
              rowKey: 'id',
              pagination: {
                pageSize: 10,
                current: 1,
                showSizeChanger: true,
                pageSizeOptions: ['5', '10', '20', '30', '40'],
                showTotal: (total, range) => `${range[0]}-${range[1]} de ${total} registros`
              }
            },
            columns: [
              {title: 'Año', dataIndex: 'year', sorter: true},
              {title: 'Mes', dataIndex: 'month', sorter: true},
              {title: 'Empleado', dataIndex: 'id_emp', sorter: true},
              {title: 'Nombre Completo', dataIndex: 'full_name', sorter: true},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_UNIDAD'), dataIndex: 'unit_id', sorter: true},
              {title: 'Nombre Unidad', dataIndex: 'unit_name', sorter: true},
              {title: 'Agencia', dataIndex: 'segment_id', sorter: true, align: 'right'},
              {title: 'Nombre Agencia', dataIndex: 'segment_name', sorter: true, align: 'right'},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_ID_CENTRO_DE_COSTOS'), dataIndex: 'cc_id', sorter: true, align: 'right'},
              {title: 'Nombre Centro de costo', dataIndex: 'cc_name', sorter: true, align: 'right'},
              {title: this.$t('PERSONALIZACION_CENTRO_COSTO_PROYECTO'), dataIndex: 'prj_id', sorter: true, align: 'right'},
              {title: 'Tipo cc', dataIndex: 'type_cc', sorter: true},
              {title: 'Distribución', dataIndex: 'distribution', sorter: true},
              {title: 'Concepto a distribuir', dataIndex: 'coc_distribution', sorter: true},
              {title: 'Documento', dataIndex: 'dist_document', sorter: true}
            ],
            actions: {
              actions: []
            }
          }
        }
      }
    },
    methods: {
      paramsTable (params) {
        this.paramsT = params
      }
    },
    computed: {
      paramsExcel () {
        return {...this.paramsT, columns: this.master.tableSetup.columns}
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Nomina/Novedades/DistributionCcHist.vue